module.exports = __webpack_public_path__ + "static/media/ring.57e91626.mp3";